import { PAMPlayersApi, PamAccountStatusResponse } from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getApi = () => BackOfficeDataServiceAPI.getBackOfficeApi(PAMPlayersApi)
const getConfig = () => BackOfficeDataServiceAPI.getBackOfficeConfig()

const reactivate = async (
  pamPlayerId: string,
  reason: string,
): Promise<PamAccountStatusResponse> => {
  return await getApi().reactivatePamPlayer({
    customerId: getConfig().customerId,
    pamPlayerId,
    pamAccountStatusBody: { reason },
  })
}

const deactivate = async (
  pamPlayerId: string,
  reason: string,
): Promise<PamAccountStatusResponse> => {
  return await getApi().deactivatePamPlayer({
    customerId: getConfig().customerId,
    pamPlayerId,
    pamAccountStatusBody: { reason },
  })
}

export const PamPlayerServiceAPI = { reactivate, deactivate }
